import React, { useContext } from "react";
import EVENTS_QUERY from "./queries/EVENTS_QUERY";
import Query from "../common/Query";
import { AppContext } from "../store";
import Loading from "../common/Loading";
import { Button, Card, Table } from "react-bootstrap";
import Event from "./interfaces/Event";
import { useNavigate, useParams } from "react-router-dom";
import JoinCTA from "../common/JoinCTA";

const EventList = () => {
  const navigate = useNavigate();
  let { chapterId }: { chapterId?: string } = useParams();
  const { state } = useContext(AppContext);
  const isVolunteer = state.orgInfo?.volunteer_access;
  const isEC = state.orgInfo?.event_coordinator;
  const loading = state.orgInfo?.loading;

  const loadDetails = (eventId: string) => {
    navigate(`/event/`, {state: {eventId}});
  };
  const displayDetails = (event: Event) => {
    const local = { ...event } as any;
    delete local.__typename;
    const body = Object.keys(local).map((k) => (
      <tr key={k}>
        <th>{k}</th>
        <td>{local[k]}</td>
      </tr>
    ));
    return (
      <Table striped hover size="sm">
        <tbody>{body}</tbody>
      </Table>
    );
  };
  const displayEvent = (event: Event) => {
    return (
      <Card key={event.EventLookupId} className="mb-3">
        <Card.Header>{event.EventName}</Card.Header>
        <Card.Body>{displayDetails(event)}</Card.Body>
        <Card.Footer>
          <Button size="sm" onClick={() => loadDetails(event.EventLookupId)}>
            Event Details
          </Button>
        </Card.Footer>
      </Card>
    );
  };
  const displayEvents = (events: Event[]) => {
    return events.map((e) => displayEvent(e));
  };
  if (isVolunteer || isEC) {
    return (
      <Query variables={{ chapterId }} query={EVENTS_QUERY}>
        {({ data: { events } }: { data: { events: Event[] } }) => {
          if (!events.length) {
            return <span>No events found for this chapter.</span>;
          } else {
            return displayEvents(events);
          }
        }}
      </Query>
    );
  } else {
    if (loading) {
      return <Loading />;
    } else {
      return <JoinCTA />;
    }
  }
};

export default EventList;
